export default "__VITE_PUBLIC_ASSET__922fec4d__"